import { apiClient } from '@/libs/api_client'
import axios from 'axios'
import { ClinicGroupUser } from '@magnetar/admin-api-interfaces'

interface ClinicGroupUserResponse {
  success: boolean
  data: ClinicGroupUser | null
  error?: {
    code: string
    message: string
  }
}

interface CreateClinicGroupUserByAccountRequest {
  clinic_group_id: number
  account: string
  user_role_id?: number
}

interface CreateNewUserAndAddToGroupRequest {
  clinic_group_id: number
  account: string
  user_name: string
  email?: string
  phone?: string
  user_role_id?: number
}

interface UpdateClinicGroupUserRequest {
  user_role_id?: number | null
}

export const clinicGroupUsersService = {
  updateClinicGroupUser: async (
    id: number,
    data: UpdateClinicGroupUserRequest,
    token: string,
  ): Promise<ClinicGroupUserResponse> => {
    try {
      const response = await apiClient.put<ClinicGroupUserResponse>(
        `/api/clinic-group-users/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ClinicGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'UPDATE_CLINIC_GROUP_USER_FAILED',
          message: '更新診所集團使用者失敗',
        },
      }
    }
  },

  deleteClinicGroupUser: async (id: number, token: string): Promise<ClinicGroupUserResponse> => {
    try {
      const response = await apiClient.delete<ClinicGroupUserResponse>(
        `/api/clinic-group-users/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ClinicGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'DELETE_CLINIC_GROUP_USER_FAILED',
          message: '刪除診所集團使用者失敗',
        },
      }
    }
  },

  createClinicGroupUserByAccount: async (
    data: CreateClinicGroupUserByAccountRequest,
    token: string,
  ): Promise<ClinicGroupUserResponse> => {
    try {
      const response = await apiClient.post<ClinicGroupUserResponse>(
        '/api/clinic-group-users/by-account',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ClinicGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'CREATE_CLINIC_GROUP_USER_FAILED',
          message: '建立診所集團使用者失敗',
        },
      }
    }
  },

  createNewUserAndAddToGroup: async (
    data: CreateNewUserAndAddToGroupRequest,
    token: string,
  ): Promise<ClinicGroupUserResponse> => {
    try {
      const response = await apiClient.post<ClinicGroupUserResponse>(
        '/api/clinic-group-users/new-user',
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )
      return response.data
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        return error.response.data as ClinicGroupUserResponse
      }
      return {
        success: false,
        data: null,
        error: {
          code: 'CREATE_NEW_USER_FAILED',
          message: '建立新使用者失敗',
        },
      }
    }
  },
}
